import { useEffect, useRef, useState } from "react";
import { useGetNotificationsQuery } from "../../../../newapi/global/notificationsSlice";
import TopbarIconButton from "../components/TopbarIconButton";
import { NotificationsOutlined } from "@mui/icons-material";
import MPONotifications from "../components/MPONotifications";
import { Box, Button, Grow, useTheme } from "@mui/material";
import { tokens } from "../../../../theme";
import { useGetNotifcationsModalQuery, useGetUnreadNotificationCountQuery } from "../../../../newapi/pwa/pwaSlice";

const TopbarNotifications = () => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const {data, isLoading} = useGetNotifcationsModalQuery('',{
        pollingInterval: process.env.NODE_ENV !== "development" ? (120000) : false,
    });
    const {data: countData} = useGetUnreadNotificationCountQuery(undefined, {
        pollingInterval: process.env.NODE_ENV !== "development" ? (120000) : false,
    });

    const prevCountRef = useRef(countData);
    const [showAnimation, setShowAnimation] = useState(false);
    const [displayedCount, setDisplayedCount] = useState(null);

    const [filterAnchorEl, setFilterAnchorEl] = useState(null);
    const filterPopoverOpen = Boolean(filterAnchorEl);
    const filterPopoverId = filterPopoverOpen ? 'simple-popover' : undefined;

    const handleFilterPopoverClick = (event) => {
        setFilterAnchorEl(event.currentTarget);
    };

    const handleFilterPopoverClose = () => {
        setFilterAnchorEl(null);
        // setExportAnchorEl(null);
    };

    useEffect(() => {
        if (countData !== undefined && countData !== null && countData > 0 && countData !== prevCountRef.current) {
        // Value changed
        setShowAnimation(true);

        // Delay updating the displayed value until after animation
        const timeout = setTimeout(() => {
            prevCountRef.current = countData;
            setDisplayedCount(countData);
            setShowAnimation(false);
        }, 300); // Adjust duration to match Grow animation

        return () => clearTimeout(timeout);
        }
    }, [countData]);
    // getUnreadNotificationCount

    return (
        <>
            <Button
                onClick={handleFilterPopoverClick}
                TouchRippleProps={{ 
                    style: { 
                        color: theme.palette.mode === "dark" ? "rgba(255,255,255,.5)" : 'rgba(49, 65, 95, 0.5)' 
                    } 
                }} // Directly styling the ripple here
                variant='contained'
                sx={{
                    background:theme.palette.mode === "dark" ? colors.nav["linkBg"]  : "#fff",
                    width:40,
                    height:40,
                    borderRadius:20,
                    padding:0,
                    minWidth:0,
                    boxShadow:"none",
                    display:"flex",
                    alignItems:"center",
                    transition:"250ms",
                    color: colors.txt["primary"],
                    position:'relative',
                    opacity:1,
                    "&:hover" : {
                        transition:"250ms",
                        background:theme.palette.mode === "dark" ? colors.grey[300] : "white",
                        boxShadow:"0px 2px 8px rgba(49, 65, 95, 0.25)"
                    },
                    "@media screen and (max-width: 47.9375em)" : {
                        width:32,
                        height:32,
                        borderRadius:16
                    }
                }}
            >
                <NotificationsOutlined />
                {countData > 0 &&
                    <Box
                    
                        sx={{
                            position:'absolute',
                            background:theme.palette.mode === "dark" ? colors.primary[400] : colors.primary[400],
                            color:theme.palette.mode === "dark" ? colors.txt['primary'] : colors.txt['light'],
                            fontWeight:"bold",
                            height:24,
                            display:'flex',
                            alignItems:"center",
                            px:0.5,
                            borderRadius:3,
                            top:-6,
                            right:-6,
                            transition: 'all 0.3s ease',
                            transform: showAnimation ? 'scale(1.3)' : 'scale(1)',
                            transition: 'transform 0.3s ease-in-out',
                        }}
                    >
                        {displayedCount}
                    </Box>
                }

            </Button>
            
            <MPONotifications
                data={data?.data}
                id={filterPopoverId}
                open={filterPopoverOpen}
                anchorEl={filterAnchorEl}
                onClose={handleFilterPopoverClose}
            />
        </>
    )
}
export default TopbarNotifications;
